import { useTaxIdConfig } from '../pages/settings/payment-and-subscription/hooks/use-tax-id-config';

export const useIsTaxIdAvailable = () => {
  const { isTaxIdAvailable } = useTaxIdConfig();
  return isTaxIdAvailable;
};
